<template lang="pug">
    div.expandCard
        table

            // Date created
            tr
                td {{ $t('fields.date') }}
                td {{ item.commentedAt | formattedDate }}

            // User full name
            tr
                td {{ $t('fields.fullName') }}
                td {{ item.fullName }}

            // Rating
            tr
                td {{ $t('fields.rating') }}
                td {{ item.rating }}

            // Comment text
            tr
                td {{ $t('fields.comment') }}
                td {{ item.comment }}
</template>

<script>
    import VueTypes from 'vue-types';
    import formattedDate from '~filters/FormattedDate';
    import phoneNumber from '~filters/Phone';

    export default {
        filters: {
            formattedDate,
            phoneNumber
        },
        props: {
            item: VueTypes.object.def({})
        }
    };
</script>
